import {RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';
import {DashboardComponent} from './components/dashboard.component';
import {LoginComponent} from './components/login.component';
import {CoreSecurityServices} from './services/core.security.services';

const coreRoutes:Routes = [
  {path:"", component:DashboardComponent, canActivate:[CoreSecurityServices]},
  {path:"login", component:LoginComponent},
];


@NgModule({
  imports:[RouterModule.forChild(coreRoutes)],
  exports:[RouterModule]
})
export class CoreRoutingModule {}
